import { useState, useEffect } from "react";
import { buscarCompatibilidades } from "../../../services/buscarCompatiblidadesService";
import {
  Agrupado,
  Compatibilidade,
  montarCompatibilidadesAgrupadas,
} from "../utils/compatibilidades";

export const useBuscarCompatibilidades = () => {
  const [compatibilidades, setCompatibilidades] = useState<Agrupado[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscarComp = async () => {
    setIsLoading(true);
    try {
      const data = await buscarCompatibilidades();
      const agrupado = await montarCompatibilidadesAgrupadas(
        (data || []) as Compatibilidade[]
      );

      setCompatibilidades(agrupado);
    } catch (error) {
      console.error("Erro ao buscar Compatibilidades:", error);
      setCompatibilidades([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    buscarComp();
  }, []);

  return { compatibilidades, isLoading, buscarComp };
};
